<template>
  <v-icon
    color="green"
    style="cursor: pointer;"
    @click="onActionClick"
  >
    mdi-calendar-check
  </v-icon>
</template>

<script>
export default {
  name: 'TableVehicleReservationActionButton',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    dataIndex: {
      type: Number,
      required: true,
      default: 0
    },
    tableData: {
      type: Array,
      default: () => ([])
    }
  },

  methods: {
    onActionClick () {
      const { onOpenReservationDialog } = this.config || {}

      if (typeof onOpenReservationDialog === 'function') {
        onOpenReservationDialog({
          data: this.tableData[this.dataIndex]
        })
      }
    }
  }
}
</script>

<style>

</style>
